module.exports = __webpack_public_path__ + "static/media/icon-system.d62003b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/search/product-list/icon-system.svg
// module id = 685
// module chunks = 1